import {Module} from "vuex";
import {CancellationRequestState, RootState} from "@/types";
import {formatDate} from "@/utils/configuration/formatters-config";

const cancellationRequestModule: Module<CancellationRequestState, RootState> = {
    namespaced: true,
    state: {
        bind: {
            decisionDate: formatDate(new Date(), "/"),
            comment: '',
            decision: ''
        }
    },
    actions: {
        cleanState({ commit }) {
            commit("setInitial");
        },
    },
    mutations: {
        setInitial(state) {
            state.bind.decisionDate = formatDate(new Date(), "/")
            state.bind.comment = ''
            state.bind.decision = ''
        },
    },
};

export default cancellationRequestModule;
